module.exports = __webpack_public_path__ + "static/img/news-img0.0082f17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-img0.jpg
// module id = Yqiq
// module chunks = 0